import UTILS from '../utils';
import { getAnswers, getShareMembers } from '../../api/post';

const plugin = {
  data() {
    return {
      answerLoading: false,
      answers: null,
      selfAnswer: null,
    };
  },
  methods: {
    postTitle(post) {
      if ('JA' == post.type) return $T('post.join.accept.title');
      if ('FA' == post.type) return $T('post.join.accept.friend.title');
      if ('JI' == post.type) return $T('post.join.invite.title');
      if ('FI' == post.type) return $T('post.join.invite.friend.title');
      return post.title;
    },
    getMessage(fieldName) {
      return this.errors.collect(fieldName);
    },
    loadAnswer(post) {
      this.answerLoading = true;
      var key = 'pa-' + post.id;
      var self = this;
      this.$commin.clientdb.getObject(key, function(data) {
        if (!data || data.t < post.expire_at) {
          if (data) {
            self.answers = data.a;
            self.setSelfAnswer(post, data.a);
          }
          getAnswers(post.id)
            .then(function(answers) {
              answers = answers ? answers : [];
              $commin.clientdb.putObject(key, {
                t: Math.floor(Date.now() / 1000),
                a: answers,
              });
              self.answers = answers;
              self.setSelfAnswer(post, answers);
              self.answerLoading = false;
            })
            .catch(function(e) {
              console.error(`failed to get answer data from pid[${post.id}]`, e);
              self.errGetData();
              self.answerLoading = false;
            });
          return;
        }

        self.answers = data.a;
        self.setSelfAnswer(post, data.a);
        self.answerLoading = false;
      });
    },
    setSelfAnswer(post, answers) {
      var cid = post.community_id;
      var cmid = this.cidToCmid(cid);
      if (!cmid) return (this.selfAnswer = null);
      for (var a of answers) {
        if (a.cmid == cmid) return (this.selfAnswer = a);
      }
      this.selfAnswer = null;
    },
    async getShareTargets(pid) {
      try {
        const cmids = await getShareMembers(pid);
        const ids = [];
        for (const cmid of cmids) ids.push(`m${cmid}`);
        return ids;
      } catch (e) {
        console.error('failed to get data', e);
        this.errGetData();
        return null;
      }
    },
  },
};

export default plugin;
